module.exports = __webpack_public_path__ + "static/media/drum.9e04417d.png";